import * as z from "zod";

const orderTrackingUsageBillingInputSchema = z.object({
  perOrderSettings: z.object({
    enabled: z.boolean(),
    includedOrders: z.number(),
    overagePricePerOrderUsd: z.number(),
  }),
  perShipmentSettings: z.object({
    enabled: z.boolean(),
    includedShipments: z.number(),
    overagePricePerShipmentUsd: z.number(),
  }),
  perSmsSettings: z.object({
    enabled: z.boolean(),
    includedCredits: z.number(),
    overagePricePerSmsUsd: z.number(),
    overagePricePerMmsUsd: z.number(),
    chargeCarrierFees: z.boolean(),
  }),
  perEmailSettings: z.object({
    enabled: z.boolean(),
    includedEmails: z.number(),
    overagePricePerEmailUsd: z.number(),
  }),
});

export type ProposedOrderTrackingInvoiceBillingInput = z.infer<
  typeof orderTrackingUsageBillingInputSchema
>;

const orderTrackingBillingWindowSnapshotSchema =
  orderTrackingUsageBillingInputSchema;

export const getOrderTrackingBillingPeriodContext = {
  name: "getOrderTrackingBillingPeriodContext" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    hasActivePeriod: z.boolean(),
    nextPeriodStart: z.date().nullable(),
    currentPeriodSnapshot: orderTrackingBillingWindowSnapshotSchema.nullable(),
  }),
};

export const previewApplyOrderTrackingBillingToCurrentPeriod = {
  name: "previewApplyOrderTrackingBillingToCurrentPeriod" as const,
  input: z.object({
    teamId: z.string(),
    proposed: orderTrackingUsageBillingInputSchema,
  }),
  output: z.object({
    usageChargeUnderCurrentConfigUsd: z.number(),
    usageChargeUnderProposedConfigUsd: z.number(),
  }),
};

export const applyOrderTrackingBillingToCurrentPeriod = {
  name: "applyOrderTrackingBillingToCurrentPeriod" as const,
  input: z.object({
    teamId: z.string(),
    proposed: orderTrackingUsageBillingInputSchema,
  }),
  output: z.object({ applied: z.boolean() }),
};
